<template>
    <div id='notfound'></div>
</template>

<script>
export default {
  name: 'notfound'
}
</script>
